export const getActiveService = (currentDashboard, currencies, allAssets) =>
    currentDashboard?.sections.reduce((result, service) => {
        if (service.type === 'Cards') {
            result.cards = service?.assets?.length || 0
        } else if (service.type === 'Crypto') {
            result.crypto = allAssets
                ?.filter(asset => asset.cryptoInfo && asset.status === 'Active')
                ?.map(asset => asset.name)
                ?.join('/')
        } else if (service.type === 'BankAccounts') {
            result.bankAccounts = service?.assets?.length || 0
        } else if (service.type === 'Money') {
            result.currencies = currencies.map(currency => currency.currencyCode)?.join('/')
        }

        return result
    }, {})
